export const Status = {
	ACTIVE: 'active',
	INACTIVE: 'inactive',
	PENDING: 'pending',
	LOADING: 'loading',
};

export type Status = (typeof Status)[keyof typeof Status];

export const NotificationStatus = {
	ERROR: 'error',
	SUCCESS: 'success',
	WARNING: 'warning',
	INFO: 'info',
};

export type NotificationStatus = (typeof NotificationStatus)[keyof typeof NotificationStatus];
